import React from 'react';
import styled from 'styled-components';
import { useImagesContext } from '../../../contexts/ImagesContext';

export const MainNumber = ({ number, height, top, left, color }) => {
  const { images } = useImagesContext();
  const imageTagList = [];
  let dividedResult = number;
  let key = 1;
  while (dividedResult > 0) {
    const oneDigitNumber = dividedResult % 10;
    imageTagList.push(
      <img
        style={{ height, position: 'relative' }}
        key={key}
        src={
          images[
            color == 'red'
              ? `main-red-${oneDigitNumber}.png`
              : `main-green-${oneDigitNumber}.png`
          ]
        }
        alt=""
      />
    );
    dividedResult = Math.floor(dividedResult / 10);
    key += 1;
  }
  return (
    <Container top={top} left={left}>
      <Background src={images['main-bg-number.png']} />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {imageTagList.reverse()}
      </div>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  width: 159px;
  height: 60px;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
`;

const Background = styled.img`
  position: absolute;
  top: 0px;
  left: 0px;
  width: 159px;
  height: 60px;
`;
